import { useRef } from 'react';
import { isString } from 'lodash';

import {
	useIsFiltersMenuOpen,
	useResetFilters,
	useSetIsFiltersMenuOpen,
} from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import {
	useCurrentFilter,
	useIsSavedSearchPillOpen,
	useSetCurrentFilter,
	useSetIsSavedSearchPillOpen,
} from 'Stores/SavedFiltersStore/SavedFiltersStore';
import Drawer from 'Storybook/core/Drawer/Drawer';
import type { OnCloseEvent } from 'Types/drawer';
import { Variant } from 'Types/variant';

import { SavedSearchPopoverContent } from '../SavedSearchPopoverContent/SavedSearchPopoverContent';
import { POPOVER_GAEVENT_CONSTS } from '../SavedSearchPopoverContent/SavedSearchPopoverContent.consts';
import { triggerSavedSearchPopoverGAEvent } from '../SavedSearchPopoverContent/SavedSearchPopoverContent.helpers';

const backdropIdentifier = 'backdrop';

export const SavedSearchDrawer: React.FC = () => {
	const setIsFiltersMenuOpen = useSetIsFiltersMenuOpen();
	const isFiltersMenuOpen = useIsFiltersMenuOpen();
	const isSavedSearchPillOpen = useIsSavedSearchPillOpen();
	const setIsSavedSearchPillOpen = useSetIsSavedSearchPillOpen();
	const isCreateSavedSearchFlow = useRef(false);
	const resetFilters = useResetFilters();
	const currentFilter = useCurrentFilter();
	const setCurrentFilter = useSetCurrentFilter();

	const onClosePopover = () => {
		setIsSavedSearchPillOpen(false);
	};

	const isDismissByBackdrop = (event: OnCloseEvent) => {
		const element = event?.target as HTMLElement;
		const backdropClassName = element?.className;
		return isString(backdropClassName) && backdropClassName?.includes(backdropIdentifier);
	};

	const onDismiss = (event: OnCloseEvent) => {
		triggerSavedSearchPopoverGAEvent(POPOVER_GAEVENT_CONSTS.closeButton);
		if (currentFilter && !isDismissByBackdrop(event)) {
			setCurrentFilter(undefined);
			resetFilters();
		}
		isCreateSavedSearchFlow.current = false;
		onClosePopover();
	};

	const onCreateSavedSearchButtonClick = () => {
		isCreateSavedSearchFlow.current = true;
		onClosePopover();
	};

	const onTransitionEnd = () => {
		const shouldOpenFiltersMenu = !isFiltersMenuOpen && !isSavedSearchPillOpen && isCreateSavedSearchFlow.current;

		if (!shouldOpenFiltersMenu) {
			return;
		}

		setIsFiltersMenuOpen(true);
		isCreateSavedSearchFlow.current = false;
	};

	return (
		<Drawer
			direction={'bottom'}
			isOpen={isSavedSearchPillOpen}
			maxSize="85%"
			onClose={onDismiss}
			onTransitionEnd={onTransitionEnd}
			size="fit-content"
			variant={Variant.SECONDARY}
		>
			<SavedSearchPopoverContent onCreateSavedSearchButtonClick={onCreateSavedSearchButtonClick} />
		</Drawer>
	);
};
